import { Segment } from "./segment.interface";
import { ReferenceImage } from "./reference-image.interface";
import { Project } from "./project.interface";

export interface Group {
    id: string;
    name: string;
    status: "active" | "processing" | "pre_gen" | "review" | "generating" | "completed" | "error" | string;
    projectId?: string | null;
    project?: Project | null;
    segments?: Segment[];
    referenceImages?: ReferenceImage[];
    finalVideoUrl?: string | null;
    finalVideoKey?: string | null;
    order: number;

    // 迁移自 Project 的生成配置
    model: string;
    aspectRatio: string;
    includeAudio: boolean;
    globalConstraints: string;
    negativePromptGlobal: string;
    structuralAnchors?: string | null;
    videoFilenamePrefix: string;
    // Phase 53: 保留上次自动生成时的原始参数
    workflowInputs?: Record<string, any> | null;

    createdAt?: string;
    updatedAt?: string;
}

export const DEFAULT_GROUP_CONFIG = {
    model: 'veo-3.1-generate-preview',
    aspectRatio: '9:16',
    includeAudio: false,
    globalConstraints: 'Perspective: fixed 45-degree phone POV. Character: single pair of human hands only. Material: strictly rigid stainless steel, no bending.',
    negativePromptGlobal: '外观发生变化',
    structuralAnchors: '',
    videoFilenamePrefix: 'veo',
};
